<template>
  <div class="login-container">
    <div class="login-card">
      <div class="login-header">
        <h1>💡 Idea Note</h1>
        <p>登录到你的笔记空间</p>
      </div>
      
      <form @submit.prevent="handleLogin" class="login-form">
        <div class="form-group">
          <label for="email">邮箱</label>
          <input 
            type="email" 
            id="email" 
            v-model="form.email" 
            placeholder="请输入邮箱" 
            required
          />
        </div>
        
        <div class="form-group">
          <label for="password">密码</label>
          <input 
            type="password" 
            id="password" 
            v-model="form.password" 
            placeholder="请输入密码" 
            required
          />
        </div>
        
        <button type="submit" class="login-btn" :disabled="loading">
          {{ loading ? '登录中...' : '登录' }}
        </button>
      </form>
      
      <div class="login-footer">
        <span>还没有账号？</span>
        <router-link to="/register" class="register-link">立即注册</router-link>
      </div>
      
      <div class="test-account">
        <h4>测试账号</h4>
        <p>邮箱: test@example.com</p>
        <p>密码: test123456</p>
      </div>
    </div>
  </div>
</template>

<script>
import apiClient from '@/api/client'
import Toastify from 'toastify-js'

export default {
  name: 'LoginView',
  data() {
    return {
      form: {
        email: '',
        password: ''
      },
      loading: false,
      error: ''
    }
  },
  methods: {
    async handleLogin() {
      this.loading = true
      this.error = ''
      
      try {
        const result = await apiClient.login({
          email: this.form.email,
          password: this.form.password
        })
        
        if (result.success) {
          // 保存token和用户信息
          apiClient.setToken(result.data.token)
          localStorage.setItem('user', JSON.stringify(result.data.user))
          
          // 显示成功提示
          this.showToast('登录成功！', 'success')
          
          // 跳转到主页
          this.$router.push('/')
        } else {
          this.error = result.error || '登录失败'
          this.showToast(this.error, 'error')
        }
      } catch (error) {
        this.error = error.message || '登录失败，请稍后重试'
        this.showToast(this.error, 'error')
      } finally {
        this.loading = false
      }
    },
    
    showToast(message, type = 'info') {
      Toastify({
        text: message,
        duration: 3000,
        gravity: "top",
        position: "right",
        style: {
          background: type === 'success' ? "#4CAF50" : type === 'error' ? "#F44336" : "#2196F3"
        }
      }).showToast()
    }
  }
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.login-card {
  background: white;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  padding: 40px;
  width: 100%;
  max-width: 400px;
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
}

.login-header h1 {
  color: #333;
  margin-bottom: 10px;
  font-size: 2em;
}

.login-header p {
  color: #666;
  font-size: 1em;
}

.login-form {
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #333;
  font-weight: 500;
}

.form-group input {
  width: 100%;
  padding: 12px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 16px;
  transition: border-color 0.3s;
}

.form-group input:focus {
  outline: none;
  border-color: #667eea;
}

.login-btn {
  width: 100%;
  padding: 14px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.3s;
}

.login-btn:hover:not(:disabled) {
  transform: translateY(-2px);
}

.login-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.login-footer {
  text-align: center;
  color: #666;
}

.register-link {
  color: #667eea;
  text-decoration: none;
  font-weight: 600;
  margin-left: 5px;
}

.register-link:hover {
  text-decoration: underline;
}

.test-account {
  margin-top: 30px;
  padding: 15px;
  background: #f5f5f5;
  border-radius: 8px;
  font-size: 14px;
}

.test-account h4 {
  margin-bottom: 10px;
  color: #333;
}

.test-account p {
  margin: 5px 0;
  color: #666;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .login-card {
    padding: 30px 20px;
  }
  
  .login-header h1 {
    font-size: 1.5em;
  }
}
</style>
